module.exports = __webpack_public_path__ + "fonts/UcCo3FwrK3iLTcvhYwYZ8UA3J58.904f3b5.woff2";